var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            title: "Novo Usuário",
            size: "lg",
            centered: "",
            "hide-footer": ""
          },
          on: { shown: _vm.onModalShown },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "userStoreForm",
              attrs: {
                model: _vm.payload,
                "label-position": "top",
                "status-icon": "",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3",
                        style: { gap: "12px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            style: { gap: "8px" }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                style: { pointerEvents: "none" },
                                attrs: {
                                  type: _vm.payload.status
                                    ? "success"
                                    : "danger",
                                  plain: "",
                                  circle: ""
                                }
                              },
                              [_c("i", { staticClass: "fas fa-user-lock" })]
                            ),
                            _vm._v(" "),
                            _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                              _vm._v(
                                "Usuário " +
                                  _vm._s(
                                    _vm.payload.status ? "Ativo" : "Inativo"
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "mb-0", attrs: { prop: "status" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "Ativo",
                                "inactive-text": "Inativo"
                              },
                              model: {
                                value: _vm.payload.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "status", $$v)
                                },
                                expression: "payload.status"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "nome" } },
                        [
                          _c("label", [_vm._v("Nome")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nome do usuário",
                              disabled: _vm.isLoading
                            },
                            model: {
                              value: _vm.payload.nome,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "nome", $$v)
                              },
                              expression: "payload.nome"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "email" } },
                        [
                          _c("label", [_vm._v("E-mail")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: "E-mail do usuário",
                              disabled: _vm.isLoading
                            },
                            model: {
                              value: _vm.payload.email,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "email", $$v)
                              },
                              expression: "payload.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "tipo_usuario" } },
                        [
                          _c("label", [_vm._v("Perfil do Usuário")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Perfil do usuário",
                                disabled: _vm.isLoading,
                                filterable: ""
                              },
                              model: {
                                value: _vm.payload.tipo_usuario,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "tipo_usuario", $$v)
                                },
                                expression: "payload.tipo_usuario"
                              }
                            },
                            _vm._l(_vm.roles, function(role) {
                              return _c("el-option", {
                                key: role.tipo,
                                attrs: { label: role.text, value: role.tipo }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.representersFiltred.length > 0
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "representante_codigo" } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.representerTitle))
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Representante",
                                    disabled: _vm.isLoading,
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.payload.representante_codigo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payload,
                                        "representante_codigo",
                                        $$v
                                      )
                                    },
                                    expression: "payload.representante_codigo"
                                  }
                                },
                                _vm._l(_vm.representersFiltred, function(
                                  representer
                                ) {
                                  return _c("el-option", {
                                    key: representer.value,
                                    attrs: {
                                      label: representer.text,
                                      value: representer.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.payload.tipo_usuario === "preposto"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "representante_preposto" } },
                            [
                              _c("label", [
                                _vm._v("Representante do Preposto")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Representante",
                                    disabled: _vm.isLoading,
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.payload.representante_preposto,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payload,
                                        "representante_preposto",
                                        $$v
                                      )
                                    },
                                    expression: "payload.representante_preposto"
                                  }
                                },
                                _vm._l(_vm.representersPrepoFiltred, function(
                                  representer
                                ) {
                                  return _c("el-option", {
                                    key: representer.value,
                                    attrs: {
                                      label: representer.text,
                                      value: representer.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.payload.tipo_usuario !== "preposto"
                    ? _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "centro_distribuicao" } },
                            [
                              _c("label", [_vm._v("Centro de distribuição")]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Centro de distribuição",
                                    disabled: _vm.isLoading,
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.payload.centro_distribuicao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payload,
                                        "centro_distribuicao",
                                        $$v
                                      )
                                    },
                                    expression: "payload.centro_distribuicao"
                                  }
                                },
                                _vm._l(_vm.centers, function(center) {
                                  return _c("el-option", {
                                    key: center.value,
                                    attrs: {
                                      label: center.text,
                                      value: center.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "password" } },
                                [
                                  _c("label", [_vm._v("Senha")]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      type: "password",
                                      placeholder: "Digite a nova senha",
                                      disabled: _vm.isLoading,
                                      autocomplete: "off",
                                      "show-password": ""
                                    },
                                    model: {
                                      value: _vm.payload.password,
                                      callback: function($$v) {
                                        _vm.$set(_vm.payload, "password", $$v)
                                      },
                                      expression: "payload.password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "password_confirmation" } },
                                [
                                  _c("label", [_vm._v("Confirmar senha")]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      type: "password",
                                      placeholder: "Confirme a nova senha",
                                      disabled: _vm.isLoading,
                                      autocomplete: "off",
                                      "show-password": ""
                                    },
                                    model: {
                                      value: _vm.payload.password_confirmation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.payload,
                                          "password_confirmation",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "payload.password_confirmation"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.payload.tipo_usuario === "gerente_regional"
                    ? _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "regional_farma" } },
                            [
                              _c("label", [_vm._v("Regional Farma")]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Selecione a regional",
                                    disabled: _vm.isLoading
                                  },
                                  model: {
                                    value: _vm.payload.regional_farma,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payload,
                                        "regional_farma",
                                        $$v
                                      )
                                    },
                                    expression: "payload.regional_farma"
                                  }
                                },
                                _vm._l(_vm.regionaisFarma, function(regional) {
                                  return _c("el-option", {
                                    key: regional,
                                    attrs: { label: regional, value: regional }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "classes_atendidas" } },
                        [
                          _c("label", [_vm._v("Classes atendidas")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                placeholder: "Todas as classes",
                                disabled: _vm.isLoading,
                                clearable: ""
                              },
                              model: {
                                value: _vm.payload.classes_atendidas,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.payload,
                                    "classes_atendidas",
                                    $$v
                                  )
                                },
                                expression: "payload.classes_atendidas"
                              }
                            },
                            _vm._l(_vm.classesDistribuidor, function(classe) {
                              return _c("el-option", {
                                key: classe.value,
                                attrs: {
                                  label: classe.label,
                                  value: classe.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "regiao_retencao" } },
                        [
                          _c("label", [_vm._v("Região da retenção")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Nenhuma (vê todas)",
                                disabled: _vm.isLoading,
                                clearable: ""
                              },
                              model: {
                                value: _vm.payload.regiao_retencao,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "regiao_retencao", $$v)
                                },
                                expression: "payload.regiao_retencao"
                              }
                            },
                            _vm._l(_vm.regioesRetencao, function(regiao) {
                              return _c("el-option", {
                                key: regiao,
                                attrs: {
                                  label: "Região " + regiao,
                                  value: regiao
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-end"
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  plain: "",
                                  disabled: _vm.isLoading
                                },
                                on: {
                                  click: function() {
                                    _vm.toggleModal()
                                    _vm.resetForm()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Cancelar\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  plain: "",
                                  disabled: _vm.isLoading
                                },
                                on: { click: _vm.onSubmit }
                              },
                              [
                                _vm.isLoading
                                  ? _c("i", { staticClass: "el-icon-loading" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-check-circle" }),
                                _vm._v(
                                  "\n                                Salvar\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ea8d199", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea8d199","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/UserCreateModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2ea8d199","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/UserCreateModal.vue
// module chunks = 2